<template>
    <basic-card>
        <data-table
            :data="currencies"
            :configuration="currencyTableConfig"
            component-id="currencies-list"
        />
    </basic-card>
</template>

<script>
    import BasicCard from "../components/layout/BasicCard";
    import DataTable from "../components/table/DataTable";
    import {mapGetters} from "vuex";
    export default {
        name: "CurrenciesListCard",
        components: {DataTable, BasicCard},
        props: {
            currencies: Array
        },
        computed: {
            ... mapGetters({
                ratesForCcy: "currencies/getValuesForCurrency"
            })
        },
        data: function () {
            return {
                currencyTableConfig: {
                    columns: [
                        {
                            caption: "Id",
                            datum: d => d.id
                        },
                        {
                            caption: "Code",
                            datum: d => d.code
                        },
                        {
                            caption: "Name",
                            datum: d => d.name
                        },
                        {
                            caption: "Date",
                            datum: d => {
                                let rates = this.ratesForCcy(d.id);
                                return rates.length > 0 ? this.$formats.formatDate(rates[0].date) : "N/A"
                            }
                        },
                        {
                            caption: "Last rate",
                            datum: d => {
                                let rates = this.ratesForCcy(d.id);
                                return rates.length > 0 ? this.$formats.formatNumber(rates[0].value /  rates[0].units / 1000, '0,0.00000') : "N/A"
                            },
                            style: d => ({'text-align': 'right'})
                        }
                    ]
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>